import { render, staticRenderFns } from "./FlatBorderCard.vue?vue&type=template&id=43f62978&"
import script from "./FlatBorderCard.vue?vue&type=script&lang=js&"
export * from "./FlatBorderCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports